export default "__VITE_ASSET__DpqXmqBp__"